// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".env[data-v-2e44cc0c]{position:fixed;top:0;left:0;line-height:1;z-index:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
